import * as $ from "jquery";
import CookiesHelper from "../Helpers/helpers.cookies";
import Handlebars from "Handlebars";

export default class CustomersComponent {
    constructor() {
        this.componentSelector = ".customer-search";
        this.instance = this;
        this.debounceTimer = null;
        this.detailsTemplateSelector = "#customer-detail-template";
        this.detailsResultTemplate;
        this.detailsResultSelector = "#customer-modal-info";
        this.cookies = new CookiesHelper();
    }

    init() {
        let instance = this;
        if ($(instance.componentSelector).length > 0) {
            instance.bind();

            const detailsTemplate = $(this.detailsTemplateSelector).html();
            if (detailsTemplate !== undefined) {
                this.detailsResultTemplate = Handlebars.compile(detailsTemplate);
            }
        }
    }

    bind() {
        let instance = this;
        $('#customer-market').off().on('change', function () {
            instance.cookies.setCookie("country", $('#customer-market').val(), 365);
            instance.search(instance, 1);
        });

        $('#customer-region').off().on('change', function () {
            instance.cookies.setCookie("region", $('#customer-region').val(), 365);
            instance.search(instance, 1);
        });

        $('#customer-query').off().on('keyup', function () {
            clearTimeout(instance.debounceTimer);
            instance.debounceTimer = setTimeout(function () {
                instance.search(instance, 1);
            }, 250);
        });

        $('#js-customer-update').off().on('click', function () {
            instance.updateCustomer(instance);
        });
        
        var savedMarket = instance.cookies.getCookie("country");
        if (savedMarket != null) {
            $('#customer-market').val(savedMarket);
        }

        $("#headbrands").on('change', function () {
            instance.search(instance, 1);
        });

        $("#mrbarber").on('change', function () {
            instance.search(instance, 1);
        });

        $("#student").on('change', function () {
            instance.search(instance, 1);
        });

        $('#customer-query').focus();
        $('#customer-query').select();


        var region = $('body').attr('data-region');
        if (region != "0")
            $('#customer-region').val(region);

        instance.search(instance, 1);
    }

    signupWKNO(instance, customerNumber, marketId) {
        axios({
            method: 'post',
            url: "/customer/SignupCustomerAsAffiliate",
            data: { customerNumber: customerNumber, marketId: marketId }
        }).then(function (response) {
            instance.getCustomerDetails(customerNumber, 1, instance);
        }).catch(function (response) {
            console.log(response);
        });
    }

    updateCustomer(instance) {
        let customerNumber = $('.update-customer #customernumber').val();
        let email = $('.update-customer #email').val();
        let organisationnumber = $('.update-customer #organisationnumber').val();
        let password = $('.update-customer #password').val();

        axios({
            method: 'post',
            url: "/customer/updatecustomer",
            data: { customerNumber: customerNumber, email: email, organisationNumber: organisationnumber, password: password }
        }).then(function (response) {
            $('.update-customer #result').html(response.data);
        }).catch(function (response) {
            console.log(response);
        });
    }

    updateFixitId(instance) {
        let customerNumber = $('.js-save-fixit').attr('data-customer')
        let fixit = $('#fixit-id').val();
        let marketId = $('#shipping-address-section').attr('data-marketid');

        $('#fixit-id').css('opacity', '0.4');

        axios({
            method: 'post',
            url: "/customer/updatefixit",
            data: { customerNumber: customerNumber, marketId: marketId, fixit: fixit }
        }).then(function (response) {
            if (response.data == "False") {
                $('#error-save-fixit').html("Fixit id upptaget");
            } else {
                $('#fixit-id').css('opacity', '1.0');
            }
        }).catch(function (response) {
            console.log(response);
        });
    }

    updateGWP(instance) {
        let customerNumber = $('.js-save-fixit').attr('data-customer')
        let gwp = $('#exclude-gwp').is(":checked");
        let marketId = $('#shipping-address-section').attr('data-marketid');

        axios({
            method: 'post',
            url: "/customer/updategwp",
            data: { customerNumber: customerNumber, marketId: marketId, gwp: gwp }
        }).then(function (response) {
        }).catch(function (response) {
            console.log(response);
        });
    }

    updateShippingAddress(instance) {
        let customerNumber = $('#shipping-address-section').attr('data-customer');
        let marketId = $('#shipping-address-section').attr('data-marketid');
        let street = $('#shipping-address').val();
        let zip = $('#shipping-zip').val();
        let city = $('#shipping-city').val();
        let id = $('#js-save-shipping').attr('data-id');
        let saloon = $('#saloon-name').val();
        let phone = $('#shipping-phone').val();

        $('.shipping-address').css('opacity', '0.4');

        axios({
            method: 'post',
            url: "/customer/UpdateShippingAddress",
            data: { customerNumber: customerNumber, marketId: marketId, id: id, street: street, zip: zip, city: city, saloon: saloon, phone: phone }
        }).then(function (response) {
            console.log(response.data);
            $('.shipping-address').css('opacity', '1.0');
        }).catch(function (response) {
            console.log(response);
        });
    }

    search(instance, page) {
        let market = $('#customer-market').val();
        let region = $('#customer-region').val();
        let query = $('#customer-query').val();

        let includeHeadbrands = $("#headbrands").prop("checked");
        let includeMrBarber = $("#mrbarber").prop("checked");
        let includeWKNO = $("#WKNO").prop("checked");
        let includeStudent = $("#student").prop("checked");

        $('tr.customers-show-more').remove();

        if (page == undefined) {
            page = 1;
        }

        if (query == "")
            query = " ";

        axios({
            method: 'post',
            url: "/customer/search",
            data: { market: market, region: region, query: query, page: page, includeHeadbrands: includeHeadbrands, includeMrBarber: includeMrBarber, includeWKNO: includeWKNO, includeStudent: includeStudent }
        }).then(function (response) {

            if (page > 1) {
                $('#result').append(response.data);
            }
            else {
                $('#result').html(response.data);
            }

            $('.js-activate-customer').off().on('click', function () {
                var customerNumber = $(this).attr('data-id');
                var marketId = $(this).attr('data-marketid');

                instance.activateCustomer(customerNumber, marketId, instance);
            });

            $('.js-customers-show-more').off().on('click', function () {
                var page = $(this).attr("data-page");
                instance.search(instance, page);
            });

            $('.js-show-customer').off().on('click', function () {
                var customerNumber = $(this).attr('data-id');
                var marketId = $(this).attr('data-marketid');
                instance.getCustomerDetails(customerNumber, marketId, instance);
            });

        }).catch(function (response) {
            console.log(response);
        });
    }

    activateCustomer(customerNumber, marketId, instance) {
        axios({
            method: 'post',
            url: "/customer/activatecustomer",
            data: { customerNumber: customerNumber, marketId: marketId }
        }).then(function (response) {
            window.location.href = "/order";
        }).catch(function (response) {
            console.log(response);
        });
    }

    getCustomerDetails(customerNumber, marketId, instance) {
        axios({
            method: 'post',
            url: "/customer/getcustomer",
            data: { customerNumber: customerNumber, marketId: marketId }
        }).then(function (response) {
            instance.showCustomerDetails(response.data, instance);
        }).catch(function (response) {
            console.log(response);
        });
    }

    showCustomerDetails(data, instance) {
        console.log(data);
        $(instance.detailsResultSelector).html(instance.detailsResultTemplate(data));

        $('.js-signup-WKNO').off().on('click', function (e) {
            var customerNumber = $(this).attr('data-customer');
            var marketId = $(this).attr('data-marketid');
            $('.js-signup-WKNO').attr('disabled', '');
            instance.signupWKNO(instance, customerNumber, marketId);
        });

        $('#js-save-shipping').off().on('click', function () {
            instance.updateShippingAddress(instance);
        });

        $('.js-save-fixit').off().on('click', function () {
            instance.updateFixitId(instance);
        });

        $('#exclude-gwp').off().on('click', function () {
            instance.updateGWP(instance);
        });

        $('#fixit-id').off().on('focus', function () {
            $('#error-save-fixit').html("");
            $('#fixit-id').val('');

        })
    }
}